export enum EMAIL_TYPE_IDS {
    WORK = 132,
    CE1 = 160,
    HOME = 150,
    CE2 = 186
};

export enum PHONE_TYPE_IDS {
    MOBILE = 147,
    HOME = 148,
    WORK = 149,
    CP1 = 302,
    CP2 = 203,
};

export enum SOCIAL_PROFILE_TYPE_IDS {
    WEBSITE = 151,
    TWITTER = 152,
    FACEBOOK = 153,
    LINKEDIN = 195,
    INSTAGRAM = 196
};

export enum CONTACT_ASSOCIATION_ID {
    ACCOUNT = 156,
    LEAD = 178,
    ORGANIZATION = 179,
    VENDOR = 166,
    TERRITORIES = 175
}

export enum CONTACT_ASSOCIATION_IDS_MODULES {
    OBJECTID_2 = 156, //Account
    OBJECTID_1 = 178,
    OBJECTID_40 = 179,
    OBJECTID_99 = 166,
    OBJECTID_5 = 175
}

export enum CUSTOMFIELD_TYPE_IDS {
    DROPDOWN = 1,
    CHECKBOX = 2,
    RADIO_BUTTON = 3,
    TOOGLE_BUTTON = 4,
    PICTURE = 5,
    FILE = 6,
    RATING = 7,
    INPUT = 8,
    DATE_PICKER = 9,
    MULTISELECT = 11,
    TREESELECT = 12,
    NUMBER = 19,
    DECIMAL = 20,
    PERCENTAGE = 21,
    CURRENCY = 22,
    MULTI_LINE = 36,
    EMAIL = 37,
    PHONE = 38,
    URL = 39,
    DATETIMEPICKER = 40,
    AUTONUMBER = 41,
    LOOKUP = 42,
    TIME = 44,
    FORMULA = 45,
    ENCRYPTEDTEXT = 46,
    RICHTEXT = 47,
    BARCODE = 48,
    IPADDRESS = 49,
    USERLOOKUP = 50,
}

export const PHONE_NUMBER_CODE_MAP = {
    contactphonework: 'workCode',
    contactphonemobile: 'mobileCode',
    contactphonehome: 'homeCode',
    contactphonecp1: 'cp1Code',
    contactphonecp2: 'cp2Code',
    assistantPhone: 'assPhoneCode',
  } as const;
